const OTHER_TAG = 'Other / Not applicable';

function normalizeTag(tag: string) {
  return tag.replaceAll(' ', '').toLowerCase();
}

export default function excludeOtherTag(tag: string) {
  return normalizeTag(tag) !== normalizeTag(OTHER_TAG);
}
